import { createSlice } from "@reduxjs/toolkit";

const getAuthSecret = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const authSecret = searchParams.get("auth_secret");
  return authSecret;
};

export const appSlice = createSlice({
  name: "app",
  initialState: {
    authSecret: getAuthSecret()
  }
});

export const appReducer = appSlice.reducer;
